// extracted by mini-css-extract-plugin
export default {"trigger":"VBDropdownTrigger_trigger__U73Ex"};